<app-common-table
  tabindex="0"
  aria-label="Student behavior history table"
  [getColumnValue]="getColumnValue"
  [columns]="columns"
  [tableFilters]="tableFilters"
  [templates]="templates"
  [dataArr]="dataArr"
  (tableFiltersUpdated)="updateTableFilters($event)">
</app-common-table>

<ng-template #actionButtons let-heroEventId="heroEventId" let-nextScheduledHeroEventId ="nextScheduledHeroEventId" let-active='active'>
  <button
    *ngIf="!!nextScheduledHeroEventId && (hasPrivilege(PrivilegeEnum.START_CLOSE_EVENTS) || hasPrivilege(PrivilegeEnum.EVENT_TRACK)) && active"
    type="button"
    mat-flat-button
    class="secondary-button icon-button"
    [routerLink]="'/scheduled-event/' + nextScheduledHeroEventId.toString()"
    options-id="OPEN_EVENT">
    OPEN
  </button>

  <button
    *ngIf="hasPrivilege(PrivilegeEnum.CREATE_EDIT_EVENTS)"
    type="button"
    mat-flat-button
    class="secondary-button icon-button"
    [routerLink]="'/event/' + heroEventId.toString()"
    options-id="EDIT_EVENT">
    EDIT
  </button>

  <button
    *ngIf="hasPrivilege(PrivilegeEnum.VIEW_HISTORICAL_EVENTS)"
    type="button"
    mat-flat-button
    class="secondary-button icon-button"
    [routerLink]="'/historical-scheduled-hero-events/' + heroEventId.toString()"
    options-id="OPEN_EVENT">
    HISTORY
  </button>



</ng-template>


<ng-template #activePill let-active = "active">
  <div *ngIf="active" class="active-pill">Active</div>
  <div *ngIf="!active" class="inactive-pill">Inactive</div>
</ng-template>
